import { useCallback, useEffect, useRef } from 'react';

import { useInView } from 'react-intersection-observer';
import { trackV2 } from 'utils/analytics';

const useFeedAnalytics = ({
  page,
  entity,
  activityId,
  feedType,
  cursorData
}) => {
  // memoise analytics props so that its only set once per card entry
  const analyticsContext = useCallback(
    (() => ({
      track: trackV2,
      props: {
        category: 'feed',
        page: entity.toLowerCase(),
        properties: {
          source: feedType === 'club' ? 'club_detail' : feedType,
          entityId: activityId,
          web_page: page,
          rank: cursorData.rank
        }
      }
    }))(),
    [entity, feedType, cursorData, activityId, page]
  );

  // intersectionObserverRef is a tag placed on any feed entry to keep track of
  // its inView status
  const [intersectionObserverRef, inView] = useInView({
    threshold: 0.5 // same as android (50%)
  });

  // only report inView status for any re-renders after the initial
  // component mount
  const isFirstRenderRef = useRef(true);

  // report screen enter/exit when the inView status of an entry changes
  useEffect(() => {
    if (!isFirstRenderRef.current) {
      analyticsContext.track({
        ...analyticsContext.props,
        action: inView ? 'screen_enter' : 'screen_exit'
      });
    } else {
      // component has now been mounted. Any changes to inViewStatus will now
      // log enter/exit analytics events
      isFirstRenderRef.current = false;
    }
  }, [inView, activityId, analyticsContext]);

  return {
    isFirstRenderRef,
    intersectionObserverRef,
    analyticsContext
  };
};

export default useFeedAnalytics;
